import React from 'react';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../../Link';
import SideMenuAccordion from './SideMenuAccordion';
import messages from '../../../locale/messages';
import s from './SideBar.css';

function SideMenuDetails({ data, handleAsPath, location, asPathName, handleMobileMenu, isMenuActive, intl }) {
  const { formatMessage } = intl;

  const handleAction = () => {
    if (handleMobileMenu) handleMobileMenu(false);
  }

  if (data?.isAccordion) {
    return (
      <SideMenuAccordion
        dataValue={data}
        handleAsPath={handleAsPath}
        location={location}
        asPathName={asPathName}
        onClick={handleAction}
      />
    )
  };

  return (
    <Link
      to={data?.href}
      onClick={() => handleAction()}
      className={cx(s.sideMenuList, ((isMenuActive || (data?.href == '/siteadmin' && location === '/siteadmin')) && s.sideMenuListActive), 'sideMenuListActiveBorderRTL')}
    >
      <span className={s.sideMenuItemIconContainer}>
        {data?.icon}
      </span>
      <span className={s.sideMenuItemTextContainer}>
        {formatMessage(messages[data?.label])}
      </span>
    </Link>
  );
}

export default injectIntl(withStyles(s)(SideMenuDetails));